import {LmEvents} from "./lm-events.type";

/**
 * Casts an unknown postMessage payload to the strongly-typed payload
 * for the given event name.
 *
 * @example
 * const payload = decodeLmPayload(LmEventNames.LOGIN, raw.payload)
 * // payload is { email?: string }
 */
export function decodeLmPayload<K extends keyof LmEvents>(event: K, payload: unknown): LmEvents[K] {
  return payload as LmEvents[K]
}
